import { useEffect, useState } from 'react'
import { useUser } from 'reactfire'

// TODO: remove automation admin gate when Pulse is GA
export function useIsAutomationAdmin(): {
  isAutomationAdmin: boolean
  loading: boolean
} {
  const { data: user } = useUser()
  const [state, setState] = useState({
    isAutomationAdmin: false,
    loading: true,
  })

  useEffect(() => {
    if (!user) {
      setState({ isAutomationAdmin: false, loading: true })
      return
    }
    let cancelled = false
    user
      .getIdTokenResult()
      .then((result) => {
        if (cancelled) return
        const { claims } = result
        // Intentionally checks only the *impersonator's* original claim, not
        // the impersonated user's. An admin impersonating an automation_admin
        // must NOT gain automation access — only the impersonator's own
        // privilege counts.
        const isAdmin = claims.impersonating
          ? claims.impersonator_automation_admin === true
          : claims.automation_admin === true
        setState({ isAutomationAdmin: isAdmin, loading: false })
      })
      .catch(() => {
        if (cancelled) return
        setState({ isAutomationAdmin: false, loading: false })
      })
    return () => {
      cancelled = true
    }
  }, [user])

  return state
}
